// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inpection-title {
    padding-bottom: 30px;
    padding-left: 50px;
  }
  
  .inpection-controls {
    padding-left: 50px;
    padding-right: 50px;
    max-width: 400px;
  }
  
  .inpection-table {
    padding-top: 30px;
  }
  
  .inspection-view-page-last-element {
    padding-bottom: 500px;
  }
  
  .inspection-modal-content {
    width: 100%;
  }

  .inspections-search-bar {
    display: flex;
    align-items: center;
    margin: 0px 10px 30px 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.7);
    background-color: var(--color-grey000);
    border-radius: 10px;
    max-width: 400px;
    flex-grow: 1;
  }

  .inspections-retrieve-options {
    display: flex;
    align-items: center;
    margin: 0px 10px 30px 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.7);
    background-color: var(--color-grey000);
    border-radius: 10px;
    max-width: 400px;
    flex-grow: 1;
  }
  
  .inspections-buttons .action-icon:hover {
    color: black;
  }
  .inspections-buttons .action-icon {
    cursor: pointer;
    color: var(--color-primaryMedium);
  }
  
  .inspections-buttons {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 20px;
    padding-bottom: 10px;
    gap: 25px;
  }
  
  .inspections-add-button {
    margin: 50px 50px 30px 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.7);
    border-radius: 10px;
    max-width: 400px;
  }
  
  /* Media query for mobile devices */
  @media (max-width: 1200px) {
    .inspections-add-button {
      margin-top: 10px;
      margin-bottom: 30px;
      margin-right: 10px;
      margin-left: 10px;
    }

    .inpection-controls {
      padding-left: 20px;
      padding-right: 20px;
      max-width: none;
    }
  
    .inpection-title {
      padding-left: 20px;
      padding-right: 20px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/containers/InspectionPage.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,yCAAyC;IACzC,sCAAsC;IACtC,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,yCAAyC;IACzC,sCAAsC;IACtC,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,2BAA2B;IAC3B,yCAAyC;IACzC,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA,mCAAmC;EACnC;IACE;MACE,gBAAgB;MAChB,mBAAmB;MACnB,kBAAkB;MAClB,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;MAClB,mBAAmB;MACnB,eAAe;IACjB;;IAEA;MACE,kBAAkB;MAClB,mBAAmB;IACrB;EACF","sourcesContent":[".inpection-title {\n    padding-bottom: 30px;\n    padding-left: 50px;\n  }\n  \n  .inpection-controls {\n    padding-left: 50px;\n    padding-right: 50px;\n    max-width: 400px;\n  }\n  \n  .inpection-table {\n    padding-top: 30px;\n  }\n  \n  .inspection-view-page-last-element {\n    padding-bottom: 500px;\n  }\n  \n  .inspection-modal-content {\n    width: 100%;\n  }\n\n  .inspections-search-bar {\n    display: flex;\n    align-items: center;\n    margin: 0px 10px 30px 10px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.7);\n    background-color: var(--color-grey000);\n    border-radius: 10px;\n    max-width: 400px;\n    flex-grow: 1;\n  }\n\n  .inspections-retrieve-options {\n    display: flex;\n    align-items: center;\n    margin: 0px 10px 30px 10px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.7);\n    background-color: var(--color-grey000);\n    border-radius: 10px;\n    max-width: 400px;\n    flex-grow: 1;\n  }\n  \n  .inspections-buttons .action-icon:hover {\n    color: black;\n  }\n  .inspections-buttons .action-icon {\n    cursor: pointer;\n    color: var(--color-primaryMedium);\n  }\n  \n  .inspections-buttons {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    padding-right: 20px;\n    padding-bottom: 10px;\n    gap: 25px;\n  }\n  \n  .inspections-add-button {\n    margin: 50px 50px 30px 10px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.7);\n    border-radius: 10px;\n    max-width: 400px;\n  }\n  \n  /* Media query for mobile devices */\n  @media (max-width: 1200px) {\n    .inspections-add-button {\n      margin-top: 10px;\n      margin-bottom: 30px;\n      margin-right: 10px;\n      margin-left: 10px;\n    }\n\n    .inpection-controls {\n      padding-left: 20px;\n      padding-right: 20px;\n      max-width: none;\n    }\n  \n    .inpection-title {\n      padding-left: 20px;\n      padding-right: 20px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
